import axios from 'axios';
import user from '../utils/user';

export default {
  async getOperationTypes() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOperationTypeByPolicyId(policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/endorsement/operation-type-configs/policy/${policyId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuotationContractData(key) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/quotations/contract-data?key=${key}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_VIDA_TOKEN}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
